import { createAsyncThunk } from '@reduxjs/toolkit';
// Utilities
import HttpClient from 'utilities/HttpClient';
import { appendStreamChunk, completeStream } from './quizAgentActions';

const _url:string = '/quiz-agent';
const _http:HttpClient = new HttpClient();

export const createThread = createAsyncThunk(
  'quizAgent/Create thread',
  async (data:any, { rejectWithValue, signal }) => {
    const response:Response = await _http.post(`${_url}/thread`, data, { signal });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);

export const sendMessage = createAsyncThunk(
  'quizAgent/Send message',
  async (data:any, { rejectWithValue }) => {
    const { threadId, ...messageData } = data;
    const response:Response = await _http.post(`${_url}/thread/${threadId}/message`, messageData);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);

export const generateImage = createAsyncThunk(
  'quizAgent/Generate image',
  async (data: { prompt: string; size: string }, { rejectWithValue }) => {
    const response:Response = await _http.post(`${_url}/image`, data);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
);

export const streamMessage = createAsyncThunk(
  'quizAgent/Stream message',
  async (data:any, { dispatch, rejectWithValue, signal }) => {
    const { threadId, ...messageData } = data;

    const response:Response = await _http.post(
      `${_url}/thread/${threadId}/stream`,
      messageData,
      { signal }
    );

    if ( !response.ok || !response.body ) {
      return rejectWithValue((await response.json().catch(() => ({}))) as any);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    signal.addEventListener('abort', () => {
      reader.cancel().catch(() => {});
    });

    while ( true ) {
      if (signal.aborted) break;

      const { value, done } = await reader.read();

      if ( done ) break;

      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split('\n\n');
      buffer = parts.pop() ?? '';

      for ( const part of parts ) {
        if (signal.aborted) break;

        const line = part.split('\n').find((l) => l.startsWith('data: '));
        if ( !line ) continue;

        let payload:any;
        try {
          payload = JSON.parse(line.slice(6));
        } catch {
          continue;
        }

        if ( payload.type === 'chunk' ) {
          dispatch(appendStreamChunk({
            draftQuiz: payload.draftQuiz,
            activities: payload.activities,
          }));
        } else if ( payload.type === 'complete' ) {
          dispatch(completeStream({
            message: payload.message,
            draftQuiz: payload.draftQuiz,
          }));
        }
      }
    }

    return null;
  }
);
